import React from 'react';
import { Link } from 'gatsby';
// eslint-disable-next-line import/no-unresolved
import willardLogo from 'assets/resources/pages/willard_logo.png';
import { IoIosArrowRoundForward } from 'react-icons/io';
import ImgHTML from '../../../ImgHTML';

import OptimizedImage from '../../../OptimizedImage';
import useSitemap from '../../../../graphql/staticQueries/useSitemap';

const AwardedLegacy = () => {
  const pages = useSitemap();
  const desiredPage = '/case-studies/willard-agri-service/';
  const altPage = '/case-studies/';
  const linkTo = pages.includes(desiredPage) ? desiredPage : altPage;
  return (
    <div className="main-beam">
      <div className="row">
        <div className="col-lg-5 col-mn-12">
          <div className="desc-section">
            <div className="subtitle bigger">Legacy Software Modernization</div>
            <div className="content">
              <p>
                Your software was great a long time ago. You need to get its
                greatness, speed and modern look back again. We will help you
                catch up and regain competitiveness thanks to your modern
                technology.
              </p>
              <p>
                <strong>We will help you:</strong>
              </p>
              <ul>
                <li>Redesign</li>
                <li>Rewrite</li>
                <li>Migrate and maintain</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-7 col-md-12">
          <div className="image-section">
            <OptimizedImage
              src="pages/willard_photo.png"
              className="img-fluid"
              alt="Willard photo"
              title="Willard photo"
            />
            <Link to={linkTo} className="company-link">
              <div className="logo">
                <ImgHTML
                  src={willardLogo}
                  alt="Logo Willard"
                  title="Logo Willard"
                />
              </div>
              <div className="link">
                <div className="read-more">
                  See related project <IoIosArrowRoundForward />
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AwardedLegacy;
